import React from 'react';
import { Activity, Server, Users, CheckCircle, AlertTriangle } from 'lucide-react';

const SystemHealth = ({ performance = {} }) => {
  const systemMetrics = performance?.system_metrics || {};
  const applicationMetrics = performance?.application_metrics || {};
  const userEngagement = performance?.user_engagement || {};

  const uptime = systemMetrics?.uptime?.percentage || systemMetrics?.uptime_percentage || 99.9;
  const responseTime = systemMetrics?.response_time?.average || applicationMetrics?.average_response_time || 150;
  const activeUsers = userEngagement?.active_users || applicationMetrics?.active_users || 0;
  const errorRate = applicationMetrics?.error_rate || applicationMetrics?.api_performance?.error_rate || 0.01;

  const healthItems = [
    {
      label: 'System Uptime',
      value: `${Number(uptime).toFixed(1)}%`,
      status: 'good',
      icon: Server
    },
    {
      label: 'Response Time',
      value: `${Number(responseTime).toFixed(0)}ms`,
      status: 'good',
      icon: Activity
    },
    {
      label: 'Active Users',
      value: activeUsers,
      status: 'good',
      icon: Users
    },
    {
      label: 'Error Rate',
      value: `${Number(errorRate).toFixed(2)}%`,
      status: errorRate > 1 ? 'warning' : 'good',
      icon: errorRate > 1 ? AlertTriangle : CheckCircle
    }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">System Health</h3>
      <div className="grid grid-cols-2 gap-4">
        {healthItems.map((item, index) => {
          const Icon = item.icon;
          return (
            <div key={index} className="p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center gap-2 mb-2">
                <Icon className={`w-4 h-4 ${
                  item.status === 'good' ? 'text-green-600' : 'text-yellow-600'
                }`} />
                <span className="text-xs text-gray-600">{item.label}</span>
              </div>
              <p className={`text-lg font-bold ${
                item.status === 'good' ? 'text-gray-900' : 'text-yellow-600'
              }`}>
                {item.value}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SystemHealth;

